import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import $ from 'jquery';
import cx from 'classnames';

// Components.
import HeaderLogo from 'components/HeaderLogo';
import HeaderMenu from 'components/HeaderMenu';
import HeaderStoreLink from 'components/HeaderStoreLink';

// Utils.
import { isWebviewApp } from 'utils';

// Styles.
import styles from './styles.module.scss';

export default class Header extends Component {

  static propTypes = {
    isFetchedProfile: PropTypes.bool.isRequired,
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    locationPath: PropTypes.string.isRequired,
  };

  state = {
    isScrolling: false,
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.onScroll, false);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.onScroll, false);
    }
  }

  onScroll = () => {
    const scroll = $(window).scrollTop();
    if (scroll > 0) {
      this.setState({ isScrolling: true });
    }
    else {
      this.setState({ isScrolling: false });
    }
  };

  render() {
    const { isFetchedProfile, auth, profile, locationPath, width, theme } = this.props;
    // Hide Header for mobile apps WebView.
    if (/data-sources-mobile-back/.test(locationPath) === true) {
      return null;
    }
    // Removed header from Measure details page.
    if (/measure-details/.test(locationPath) === true) {
      return null;
    }
    const isSharedDashboardStatus = auth.userType === 'share';
    const isDemoPages = /data-sources|lms/.test(locationPath) === true;
    const isDemo = isDemoPages && (!auth.isAuthenticated || (auth.isAuthenticated && (!profile.is_ios_user && !profile.is_android_user)));
    return (
      <div className={cx(styles.header, { [styles.isScrolling]: this.state.isScrolling === true }, 'header', { 'isScrolling': this.state.isScrolling === true }, { [styles.isDemo]: isDemo }, { [styles.darkTheme] : theme === 'ink' } )}>
        <div className="container-fixed" style={{ width: width }}>
          <Grid container alignItems="center" className={styles.headerGridContainer}>
            <Grid item xs={4} sm={4}>
              <HeaderLogo theme={theme} />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }

}
